import { render, staticRenderFns } from "./cpt-dataV-digitalFlop.vue?vue&type=template&id=423626b6&scoped=true"
import script from "./cpt-dataV-digitalFlop.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-digitalFlop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423626b6",
  null
  
)

export default component.exports